module.exports = __webpack_public_path__ + "img/marc_pannekoek.75012502.png";